import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { priceToday, totalValue } from '../data/content';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-104" data-mp="3ucvg40pi5vo5">
      {visible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-blush bg-ivory/95 backdrop-blur" data-id="element-105" data-mp="3ueq09csy9jr6">
          <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-3 lg:px-10" data-id="element-106" data-mp="gxpasvkqp31v">
            <div className="min-w-0" data-id="element-107" data-mp="75vt9ghykvbc">
              <p className="truncate font-display text-lg leading-tight text-ink sm:text-xl" data-id="element-108" data-mp="76xbc4xe6i2k">
                Wedding Bliss &amp; Fun System™
              </p>
              <p className="font-sans text-xs text-muted" data-id="element-109" data-mp="gvfa6gm42f3k">
                <span className="line-through" data-id="element-110" data-mp="gx05i8g9222h">{totalValue}</span>{' '}
                <span className="font-semibold text-wine" data-id="element-111" data-mp="c3xkwptga2yf">Hoy {priceToday} ARS</span> · Acceso
                inmediato
              </p>
            </div>
            <CtaButton size="md" className="shrink-0" data-id="element-112" data-mp="py7zwffnaira">
              Quiero el pack
            </CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}